// Static content loader. Reads from /content/*.json in /public.
// No backend, no axios — pure fetch against static assets.

const PUB = process.env.PUBLIC_URL || "";

const cache = {};
const loadJSON = async (path) => {
  if (cache[path]) return cache[path];
  const res = await fetch(`${PUB}${path}`, { cache: "no-cache" });
  if (!res.ok) throw new Error(`Failed to load ${path}`);
  const data = await res.json();
  cache[path] = data;
  return data;
};

export const fetchProducts = async (params = {}) => {
  const data = await loadJSON("/content/products.json");
  let items = data.items || [];
  if (params.category) items = items.filter((p) => p.category === params.category);
  if (params.featured !== undefined) items = items.filter((p) => !!p.featured === !!params.featured);
  return items;
};

export const fetchTestimonials = async () => {
  const data = await loadJSON("/content/testimonials.json");
  return data.items || [];
};

export const fetchNavigation = async () => {
  const data = await loadJSON("/content/navigation.json");
  return data.items || [];
};

export const fetchGallery = async () => {
  const data = await loadJSON("/content/gallery.json");
  return data.items || [];
};
